<template>
  <el-dialog :title="fileName" :visible.sync="visible" :fullscreen="true">
    <component v-bind:is="tabView" style=" width: 98vw; height: calc(100vh - 120px)" v-loading="loading" :src="fileUrl"
      @rendered="renderedHandler" @error="errorHandler">
    </component>
    <!-- <vue-office-excel v-loading="loading" :src="excel" style="height: 85vh;width: 100%;" @rendered="renderedHandler"
      @error="errorHandler" /> -->
  </el-dialog>

  <!-- <vue-office-excel :src="excel" style="height: 100vh;" @rendered="renderedHandler" @error="errorHandler" /> -->
</template>

<script>
//引入VueOfficeExcel组件
import VueOfficeExcel from '@vue-office/excel'
import VueOfficeDocx from '@vue-office/docx'
import VueOfficePdf from '@vue-office/pdf'
//引入相关样式
import '@vue-office/excel/lib/index.css'

export default {

  props: {
    "tabView": {
      type: String,
      default: "excel"
    },
    "fileUrl": {
      type: String,
      default: ""
    },
    "fileName": {
      type: String,
      default: "预览"
    }
  },
  components: {
    VueOfficeExcel,
    VueOfficeDocx,
    VueOfficePdf
  },
  data() {
    return {
      loading: false,
      visible: false,
      show: true,
      // excel: 'https://localhost:7242/api/v1/HandleContractFile/files/289f2fec-7b3e-491a-a283-6c1cbbecb181'//设置文档地址
    }
  },

  watch: {
    fileUrl(val) {
      this.loading = true;
    }
  },
  methods: {
    renderedHandler() {
      this.loading = false
      // console.log("渲染完成")
    },
    errorHandler() {
      this.loading = false

      console.log("渲染失败", this.fileUrl)
    },

  }
}
</script>